module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "chap-002"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_tit"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("JOSHUA COMMANDS THE TRIBES"), _c('br')]), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Joshua+1%3A10-18&version=RSV",
      "target": "_blank"
    }
  }, [_vm._v("JOSHUA 1:10-18")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERVIEW")]), _vm._v(":")]), _vm._v(" As Joshua commands the people to prepare food for the three-day journey to enter the land they are to possess, the mystery of the Trinity and the sacrament of baptism are signified. To follow the Lord into the promised land, the food of good works is needed for the journey (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AESARIUS OF")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RLES")]), _vm._v("). The inheritances determined through Moses and Joshua represent two groups: those who are firstborn according to nature and those who receive the blessing through grace. Strong men, who signify defenders of the truth, go out into the battle, while the infants and women, who signify those who are silent and weak, offer us no aid in the fight (O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v(").")]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-015"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('span', {
    staticClass: "r"
  }, [_c('b', [_vm._v("1:10-11 ")])]), _vm._v("Joshua Commands the Officers")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YSTERY OF THE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RINITY")]), _vm._v(".")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AESARIUS OF")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RLES")]), _vm._v(": At the death of Moses, Joshua received the rule; and when the law ended, our true Lord Jesus obtained the rule of the whole world. Therefore, Joshua who typified the Lord said to the people when he came to the Jordan: “Prepare your provisions until the third day.” The third day, dearly beloved, we recognize as the mystery of the Trinity. What food should we prepare so that we may come to the third day? It seems to me that this food should be understood as faith; for Christians it is by faith that they believe in the Trinity and arrive at the sacrament of baptism. Therefore, what Joshua then told his people, the true Joshua or Jesus now tells the Christian people through his ministers. Indeed, what else does this mean: “Prepare your provisions until the third day,” except to receive the mystery of the Trinity? After this the Jordan was crossed just as if the mystery of baptism were completed, and the people of Israel entered the promised land. It is true, brothers; unless a person crosses through the sacrament of baptism, he will not see the land of true promise, that is, eternal beatitude. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERMON")]), _vm._v(" 115.1."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN53",
      "id": "ap_part1_NFIN53-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea "
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOD OF")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOD")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORKS")]), _vm._v(".")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AESARIUS OF")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RLES")]), _vm._v(": For this reason Joshua said to the people, “Prepare your provisions for the journey.” Today, if you willingly listen, Christ our Lord says to you, “If you will follow me, prepare food for the journey.” This food is good works which accompany us like faithful food for the journey to future bliss. Therefore, consider, brothers, that if each one does not prepare food for himself, he cannot "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("follow Joshua when he enters the land of promise. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERMON")]), _vm._v(" 116.2.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN54",
      "id": "ap_part1_NFIN54-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-016"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('span', {
    staticClass: "r"
  }, [_c('b', [_vm._v("1:12-15 ")])]), _vm._v("A Reminder of Moses’ Words")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NHERITANCE OF THE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRSTBORN")]), _vm._v(". ")]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _c('b', [_vm._v(": ")]), _vm._v("Let us look closely at what sign those two and a half tribes hold who receive the land of inheritance through Moses, and what sign the remainder of the nine and a half tribes hold who receive the promise of the holy land through Jesus [Joshua].")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("First of all, I think it is impossible for it to have happened accidentally that those who receive a portion through Moses were all firstborn. For Reuben was the firstborn of Leah;"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN55",
      "id": "ap_part1_NFIN55-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Gad, the firstborn of Zilpah;"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN56",
      "id": "ap_part1_NFIN56-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" and Manasseh, the firstborn of Asenath the Egyptian whom Joseph married, the daughter of Potiphar the priest of Heliopolis."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN57",
      "id": "ap_part1_NFIN57-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" For myself, I can never be persuaded that it was by chance that the firstborn were the only ones whose inheritance was determined through Moses. Rather, I believe that in these things the design of two groups of people was already foreshadowed at that time: One would seem to be the firstborn according to the order of nature; the other, the people who would receive the blessing of their inheritance through faith and grace. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA")]), _vm._v(" 3.1."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN58",
      "id": "ap_part1_NFIN58-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea "
  }, [_c('b', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SSISTANCE IN THE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATTLE")]), _vm._v(".")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v(": Rest is not given first to those who through Moses receive the inheritance—that is, those who pleased God through the law—unless they assist their brothers in the battles. Only women and infants receive rest through Moses. The others do not rest but go out to the aid of their brothers. . . .")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Thus those who are strong men, their loins armed and girded with truth, go forth to our aid and fight with us. But “infants and women” do not go out to our battle. This is not an astonishing thing, for an infant is said to be one who does not speak. How is a person able to assist me who has spoken nothing, the one of whom I discover nothing that I may read, the one who does not instruct me by a word? But the apostle says that a woman is a “weak vessel.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN59",
      "id": "ap_part1_NFIN59-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" Suitably, therefore, a weak vessel does not come to the conflict lest it be broken in pieces and destroyed. For concerning our Lord Jesus, it is also said in the Gospels that “he did not break a bruised reed.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN60",
      "id": "ap_part1_NFIN60-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA")]), _vm._v(" 3.1."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN61",
      "id": "ap_part1_NFIN61-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09aa1e8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap2.vue
// module id = 84
// module chunks = 0